import * as React from "react";

import { SimpleComponent } from "./SimpleComponent"
import { appContext } from "../App/appContext"

import Models = Gf.Web.Models;

export interface ILinkButtonProps {
    className?: string;
    onClick?: React.MouseEventHandler<{}>;
    to: string; // Only used if javascript is turned off
    disabled?: boolean;
    flagg?: Models.HandlingFlagg;
}

export class LinkButton extends SimpleComponent<ILinkButtonProps> {
    constructor(props: ILinkButtonProps) {
        super(props);
    }

    render() {
        return <a
           className={`linkButton ${this.props.className || "defaultButton"}` }
           href={appContext.addContextPathAndFixUrl(this.props.to)}
           onClick={this.props.onClick ? (evt: React.MouseEvent<{}>) => {
               evt.preventDefault();
               return this.props.onClick ? this.props.onClick(evt) : undefined;
           } : undefined}>{this.props.children}</a>;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/LinkButton.tsx